export default {
  OSCILLOGRAPHY: 'oscillography',
  INFODATA: 'info_data',
  DIAGNOSTICS: 'diagnostics',
};
